import api from '~/services/api';

const baseURL = CONFIG.djangoBaseUrl;
const deleteBaseURL = CONFIG.armorUrl;

const uploadCSV = (file: Blob | string) => {
  const formData = new FormData();
  formData.append('file', file);

  return api.request({
    baseURL,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    url: 'user/orders/import/csv/v2/ajaxpreload/',
  });
};

const getTemplates = () =>
  api.request({
    baseURL,
    method: 'GET',
    url: 'user/orders/import/csv/v2/mapping/',
  });

const saveTemplate = (payload) =>
  api.request({
    baseURL,
    data: payload,
    method: 'POST',
    url: 'user/orders/import/csv/v2/mapping/',
  });

const deleteTemplate = (payload) =>
  api.request({
    baseURL: deleteBaseURL,
    data: payload,
    method: 'DELETE',
    url: 'user/orders/import/csv/v2/mapping/',
  });

const importCSVOrders = (payload) =>
  api.request({
    baseURL,
    data: payload,
    method: 'POST',
    url: 'user/orders/import/csv/v2/',
  });

export { deleteTemplate, getTemplates, importCSVOrders, saveTemplate, uploadCSV };
